import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Flex, Image, Text } from 'rebass';
import DropDown, { DropDownItem } from 'components/DropDown';
import { changeUserStatus } from 'actions/user';
import useDropDownHandlers from 'hooks/useDropDownHandlers';
import arrowIcon from 'assets/icons/arrow.png';
import useModal from 'hooks/useModal';

const UserStatusDropDown: React.FC<any> = ({ userId, userStatus, userRole }): JSX.Element => {
  const { isDropDownVisible, openDropDown, closeDropDown } = useDropDownHandlers();

  const { openModalHandler } = useModal();
  const dispatch = useDispatch();
  const changeUserStatusHandler = useCallback(
    (status: string) => () => {
      dispatch(changeUserStatus({ status, userId, userRole }));
    },
    [userId, userRole, dispatch]
  );

  return (
    <Flex
      alignItems="baseline"
      onClick={() => openDropDown(userId)}
      css="position: relative; cursor: pointer;"
    >
      <Image src={arrowIcon} />
      <DropDown
        visible={isDropDownVisible === userId}
        minWidth="65px"
        onClose={() => isDropDownVisible === userId && closeDropDown()}
      >
        {userStatus === 'ACTIVE' ? (
          <DropDownItem
            name="pending"
            padding="5px"
            onClick={() => {
              closeDropDown();
              openModalHandler({
                title: 'confirm',
                data: {
                  title: ' Are you sure that you want to change the status?',
                  confirmHandler: changeUserStatusHandler('PENDING'),
                },
              })();
            }}
          />
        ) : (
          <DropDownItem
            name="active"
            padding="5px"
            onClick={() => {
              closeDropDown();
              openModalHandler({
                title: 'confirm',
                data: {
                  title: ' Are you sure that you want to change the status?',
                  confirmHandler: changeUserStatusHandler('ACTIVE'),
                },
              })();
            }}
          />
        )}
      </DropDown>
      <Text ml={1}>{userStatus}</Text>
    </Flex>
  );
};

export default UserStatusDropDown;
